import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { TagadaPayRouterConfigurationCard } from './components/tagadapay-router-configuration-card'
import { TagadaPayRouterDescriptorCard } from './components/tagadapay-router-descriptor-card'
import { TagadaPayRouterFeaturesCard } from './components/tagadapay-router-features-card'
import { TagadaPayRouterApmCard } from './components/tagadapay-router-apm-card'

interface TagadaPayRouterDetailsPageProps {
    processor: ProcessorDetails
}

export const TagadaPayRouterDetailsPage = ({ processor }: TagadaPayRouterDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="tagadapay-router"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <TagadaPayRouterConfigurationCard processor={processor} />
            <TagadaPayRouterDescriptorCard processor={processor} />
            <TagadaPayRouterApmCard processor={processor} />
            <TagadaPayRouterFeaturesCard />
        </>
    )
}
